<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div ref="chartWrapperOpts"
         class="widget-contents-option"
    >
      <div style="flex: 1"></div>
      <q-select style="width: 80px;"
                class="bs bs-q-sm bs-q-select bs-q-select-default"
                :value="opts.unit"
                :options="sortByOptions"
                :auth-force="true"
                @change="onChangeChartOptions"
      />
    </div>
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <trend-chart ref="chartInstance"
                     class="widget-contents-chart"
                     :grid="{ left: '60px', right: '1%'}"
                     :data="widgetData"
                     :x-axis="xAxis"
                     :y-axis="yAxis"
                     :series="series"
                     :tooltip="tooltip"
                     :zoom="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
// import Moment from 'moment'
// Mixin 객체
import {widgetMixin} from '~/mixins/widgetCommonMixin'
// 차트 컴포넌트
import {top10ColorArea} from '~/utils/charts'
// 스토어 헬퍼
import {createNamespacedHelpers} from 'vuex'
// 스토어 헬퍼 객체
const {mapGetters} = createNamespacedHelpers('common/common/')
const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

export default {
  name: 'widgetFwAdTrafTrend',
  mixins: [widgetMixin],
  data () {
    return {
      w: 3,
      self: this,
      opts: {
        unit: 'bps'
      },
      title: 'widgetFwAdTrafTrend',
      series: [
        {id: 'fwAdTrafficAllowIn', type: 'line', name: 'Allow', smooth: 0.6, valueYField: 'in_allow', lineStyle: {width: 1}, areaStyle: {color: top10ColorArea[0]}, symbol: 'circle', showSymbol: false, triggerLineEvent: true},
        {id: 'fwAdTrafficAllowOut', type: 'line', name: 'Allow', smooth: 0.6, valueYField: 'out_allow', lineStyle: {width: 1}, areaStyle: {color: top10ColorArea[0]}, symbol: 'circle', showSymbol: false, triggerLineEvent: true},
        {id: 'fwAdTrafficDenyIn', type: 'line', name: 'Deny', smooth: 0.6, valueYField: 'in_deny', lineStyle: {width: 1}, areaStyle: {color: top10ColorArea[1]}, symbol: 'circle', showSymbol: false, triggerLineEvent: true},
        {id: 'fwAdTrafficDenyOut', type: 'line', name: 'Deny', smooth: 0.6, valueYField: 'out_deny', lineStyle: {width: 1}, areaStyle: {color: top10ColorArea[1]}, symbol: 'circle', showSymbol: false, triggerLineEvent: true}
      ],
      isLock: false,
      isMove: true,
      isResize: true,
      eventBus: true,
      deviceType: [20],
      // isIpType: true,
      allUpdate: false,
      restData: {
        result: [],
        unit_time: ''
      },
      widgetData: [],
      timerValue: 10000,
      timerObject: null,
      lastEndTime: '',
      // TAMS
      autoAlignTimer: void 0,
      xAxisRawData: {
        type: 'time',
        axisLine: {onZero: true},
        axisLabel: {
          formatter: '{HH}:{mm}:{ss}  ',
          hideOverlap: true
        }
      },
      yAxisRawData: [
        {
          name: 'In',
          max: 1,
          min: -1,
          type: 'value',
          position: 'left',
          axisLabel: {
            formatter: value => this.opts.unit === 'bps' ? this.bpsConverter(Math.abs(value)) : this.ppsConverter(Math.abs(value))
          },
          nameLocation: 'center',
          nameRotate: 0,
          nameGap: 80,
          nameTextStyle: {
            verticalAlign: 'bottom',
            lineHeight: this.isMaximumWidget ? 400 : 80
          }
        },
        {
          name: 'Out',
          type: 'value',
          position: 'left',
          nameLocation: 'center',
          nameRotate: 0,
          nameGap: 80,
          nameTextStyle: {
            verticalAlign: 'top',
            lineHeight: this.isMaximumWidget ? 400 : 80
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getDeviceTime'
    ]),
    xAxis: {
      get () {
        return this.xAxisRawData
      },
      set (options) {
        this.xAxisRawData = options
      }
    },
    yAxis: {
      get () {
        return this.yAxisRawData
      },
      set (options) {
        this.yAxisRawData = options
      }
    },
    tooltip () {
      return {
        axisPointer: {type: 'line'},
        formatter: (params) => {
          const dictLabelName = {
            'fwAdTrafficAllowIn': 'Allow (In)',
            'fwAdTrafficAllowOut': 'Allow (Out)',
            'fwAdTrafficDenyIn': 'Deny (In)',
            'fwAdTrafficDenyOut': 'Deny (Out)'
          }
          let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
          for (let i = 0, max = params.length; i < max; i++) {
            const traffic = Math.abs(params[i].value[1])
            const seriesName = _.get(dictLabelName, [params[i].seriesId], '')
            resFormat += `${params[i].marker}${seriesName} : <b>${this.opts.unit === 'bps' ? this.bpsConverter(traffic) : this.ppsConverter(traffic)}</b><br>`
          }
          return resFormat
        }
      }
    },
    sortByOptions () {
      return [
        {
          label: 'bps',
          value: 'bps'
        },
        {
          label: 'pps',
          value: 'pps'
        }
      ]
    }
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    // 타이머 객체 생성
    // this.timerObject = setInterval(this.getWidgetContentsData, this.timerValue)
  },
  beforeUpdate () {},
  updated () {},
  activated () {},
  deactivated () {},
  beforeDestroy () {
    // if (this.timerObject) {
    //   clearInterval(this.timerObject)
    // }
    // 랜더링 이후 차트 중앙정렬 타이머
    if (this.autoAlignTimer) {
      clearTimeout(this.autoAlignTimer)
    }

    // 셀프 객체 초기화
    this.self = null
  },
  destroyed () {},
  errorCaptured () {},
  methods: {
    ...mapActions([
      'getWidgetData'
    ]),
    setYAxisMaxValue () {
      const chart = this.$refs.chartInstance
      const {dataMax, dataMin} = chart.yAxis[0].getExtremes()
      let allMaxValue = (dataMax > Math.abs(dataMin)) ? dataMax : Math.abs(dataMin)
      allMaxValue = (allMaxValue === 0) ? 100 : allMaxValue * 1.1

      // chart.yAxis[0].setExtremes(-allMaxValue, allMaxValue)
      chart.yAxis[0].update({
        min: -allMaxValue,
        max: allMaxValue
      })
    },
    async onChangeChartOptions (value) {
      this.opts.unit = value
      this.getWidgetContentsData(true)
    },
    // 위젯 대상 장비 필터 설정.
    async onChangeWidgetMachId ({machId}) {
      // 위젯 옵션 변경 - 저장에 필요한 값???
      this.opts.mach_id = machId
      this.getWidgetContentsData(true, machId)
    },
    async getWidgetContentsData (init = false, extraParams = null) {
      const contentsOptions = {
        widgetType: 'fw_traffic_trend'
      }

      // 장비 filter 추가
      if (this.opts.mach_id) {
        contentsOptions.machId = this.opts.mach_id
      }

      // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
      if (extraParams && extraParams.machId) {
        contentsOptions.machId = extraParams.machId
      }

      // Progress 출력 여부
      this.showProgress(true)

      // initFlag가 True면 기존 차트 데이터 초기
      if (init) {
        // 위젯 데이터 초기화
        this.widgetData = []

        // Series 초기화
        this.$refs.chartInstance.clear()
      }

      // 요청 전 차트 업데이트 처리지정
      // this.allUpdate = init

      // API 호출
      // const {code, eTime, result} = await this.getWidgetData(contentsOptions)
      const {code, result} = await this.getWidgetData(contentsOptions)

      // 마지막 시간 저장 (14:04:59 저장)
      // this.lastEndTime = eTime

      // Series 데이터 구성
      // if (code === 'ok' && result.result.length > 0) {
      if (code === 'ok' && _.get(result, ['result', 'length'], 0) > 0) {
        // Rest data 초기화
        this.restData = result

        // 허용 - Inbound 데이터
        // const time = []
        const unit = this.opts.unit === 'bps' ? 'bytes' : 'packets'
        const inboundDeny = [], outboundDeny = []
        const inboundAllow = [], outboundAllow = []
        let inAllowBiggest = 0, outAllowBiggest = 0, inBlockBiggest = 0, outBlockBiggest = 0

        if (result.result.length > 0) {
          for (const trafficData of result.result) {
            inAllowBiggest = Math.max(inAllowBiggest, trafficData[`in_allow_${unit}`])
            inBlockBiggest = Math.max(inBlockBiggest, trafficData[`in_deny_${unit}`])
            outAllowBiggest = Math.max(outAllowBiggest, Math.abs(trafficData[`out_allow_${unit}`]))
            outBlockBiggest = Math.max(outBlockBiggest, Math.abs(trafficData[`out_deny_${unit}`]))

            // time.push(trafficData.time)

            inboundAllow.push([trafficData.time, trafficData[`in_allow_${unit}`]])
            outboundAllow.push([trafficData.time, trafficData[`out_allow_${unit}`]])

            inboundDeny.push([trafficData.time, trafficData[`in_deny_${unit}`]])
            outboundDeny.push([trafficData.time, trafficData[`out_deny_${unit}`]])
          }
        }

        const allowMax = Math.max(inAllowBiggest, outAllowBiggest)
        const blockMax = Math.max(inBlockBiggest, outBlockBiggest)
        const totalMax = Math.max(allowMax, blockMax)

        this.yAxis[0].max = totalMax + (totalMax * 0.3) || 1
        this.yAxis[0].min = -totalMax - (totalMax * 0.3) || -1

        // this.xAxis.data = time

        this.widgetData = [inboundAllow, outboundAllow, inboundDeny, outboundDeny]
      } else {
        // TAMS - All update 기준
        // 위젯 데이터 초기화
        this.widgetData = []

        // Series 초기화
        this.$refs.chartInstance.clear()
      }

      // Progress 출력 여부
      this.showProgress(false)
    }
  },
  watch: {}
}
</script>
<style scoped>
.widget-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.widget-contents-option {
  right: 0;
  display: flex;
  padding-top: 5px;
  padding-right: 5px;
  margin-bottom: 5px;
}

.widget-contents {
  display: flex;
}

.widget-contents-wrapper {
  flex-grow: 1;
  display: flex;
  position: relative;
}

.widget-contents-option {
  z-index: 10;
  right: 0;
  display: flex;
  position: absolute;
  padding-top: 5px;
  padding-right: 17px;
  margin-bottom: 5px;
}

.widget-contents-chart {
  flex-grow: 1 !important;
}
</style>
